import { useEffect, useState } from 'react';

// A UI resend delay only; the API remains authoritative for rate limits.
export const useCountdown = () => {
    const [secondsRemaining, setSecondsRemaining] = useState(0);
    useEffect(() => {
        if (secondsRemaining <= 0) return;
        const timer = setTimeout(() => setSecondsRemaining(seconds => seconds - 1), 1000);
        return () => clearTimeout(timer);
    }, [secondsRemaining]);
    return [secondsRemaining, setSecondsRemaining];
};
